module.exports = __webpack_public_path__ + "img/buck-icon.584f55e7.png";